import { designHeight } from './layerConfig';

export const layoutSize = designHeight;

// 地图原始中心点
export const layoutOriginCenter = ['50%', '50%'];
export const layoutOriginCenterObject = {
  x: '50%',
  y: '50%',
};

// 地图原始偏移中心点
export const layoutOriginOffsetCenter = ['50.3%', '50.5%'];

// 地图目标中心点
export const layoutTargetCenter = ['31.25%', '50%'];
export const layoutTargetCenterObject = {
  x: '31.25%',
  y: '50%',
};

// 地图目标偏移中心点
export const layoutTargetOffsetCenter = ['31.55%', '50.5%'];
export const layoutTargetOffsetObject = {
  x: '31.55%',
  y: '50.5%',
};
